import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  CircularProgress,
  Typography,
  Box,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { appUrl } from "../../../../../../utils/config";
import axios from "axios";

const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 650,
  },
  tableContainer: {
    boxShadow: "none", // Remove border and shadow from the container
  },
  tableCell: {
    textAlign: "left",
    backgroundColor: "#E5F2F7",
    borderBottom: "none", // Remove bottom border
    padding: "16px", // Standard padding for consistency
  },
  tableCell2: {
    textAlign: "left",
    backgroundColor: "#E5F2F7",
    borderBottom: "none", // Remove bottom border
    padding: "16px", // Standard padding for consistency
    paddingTop: "0px",
  },
  headerCell: {
    fontWeight: "bold",
  },
}));

const ProductDetailsLoader = ({
  collabrixProductID,
  poNumber,
  materialPlantID,
  materialStorageLocationID,
  batchNumber,
  vendorMosymphonyID,
  vendorPlantID,
  sponsorStorageLocation,
  onProductCodeFetched,
  // Fallbacks sourced from the delivery-schedule-batch details (previous screen), used when
  // the product-config fetch returns nothing (e.g. products loaded with collabrixProductID=0).
  fgMaterialCode,
  fgMaterialName,
  cmoName,
}) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [productDetails, setProductDetails] = useState(null);
  const [vendorPlantDetails, setVendorPlantDetails] = useState(null);
  const [error, setError] = useState(null);

  // Helper function to present formatted data
  const presentFormatedData = (data) => {
    if (!data || data === "" || data === null || data === undefined) {
      return "NA";
    }
    return data;
  };

  // API function for fetching product details
  const fetchProductDetails = async (productID) => {
    try {
      const response = await axios.get(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchProductDetails/${productID}`
      );

      return response.data;
    } catch (error) {
      console.error("Error fetching product details:", error);
      throw error;
    }
  };

  // API function for fetching vendor plant details
  const fetchVendorPlantDetails = async (productID) => {
    try {
      const response = await axios.get(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchVendorPlantDetails/${vendorMosymphonyID}`
      );

      return response.data;
    } catch (error) {
      console.error("Error fetching vendor plant details:", error);
      throw error;
    }
  };

  useEffect(() => {
    const loadProductAndVendorDetails = async () => {
      if (!collabrixProductID) {
        return;
      }

      
      setLoading(true);
      setError(null);

      try {
        // Call both APIs in parallel
        const [productResponse, vendorPlantResponse] = await Promise.all([
          fetchProductDetails(collabrixProductID),
          fetchVendorPlantDetails(collabrixProductID),
        ]);


        // Store the responses in state
        setProductDetails(productResponse);
        setVendorPlantDetails(vendorPlantResponse);
        
        // Pass product code back to parent if callback provided
        if (onProductCodeFetched && productResponse?.data?.productDetails?.productCode) {
          onProductCodeFetched(productResponse.data.productDetails.productCode);
        }
      } catch (err) {
        console.error("Error loading product/vendor details:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    loadProductAndVendorDetails();
  }, [collabrixProductID]);

  // if (!collabrixProductID) {
  //   return (
  //     <Box p={2}>
  //       <Typography variant="body2" color="textSecondary">
  //         No collabrixProductID available
  //       </Typography>
  //     </Box>
  //   );
  // }

  if (loading) {
    return (
      <Box display="flex" alignItems="center" p={2}>
        <CircularProgress size={20} style={{ marginRight: "8px" }} />
        <Typography variant="body2">
          Loading product and vendor details...
        </Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Box p={2}>
        <Typography variant="body2" color="error">
          Error loading details: {error}
        </Typography>
      </Box>
    );
  }

  return (
    <React.Fragment>
      {/* Product Details Table - Matching ViewStructuredInformation.jsx structure */}
      {/* {productDetails && productDetails.data && ( */}
        <Grid
          container
          justifyContent="flex-start"
          style={{ backgroundColor: "#c2e1ef" }}
        >
          <Grid item>
            <TableContainer
              component={Paper}
              className={classes.tableContainer}
            >
              <Table className={classes.table} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell
                      className={`${classes.tableCell} ${classes.headerCell}`}
                    >
                      PO Number
                    </TableCell>
                    <TableCell
                      className={`${classes.tableCell} ${classes.headerCell}`}
                    >
                      CMO
                    </TableCell>
                    <TableCell
                      className={`${classes.tableCell} ${classes.headerCell}`}
                    >
                      Product Code / Description
                    </TableCell>
                    <TableCell
                      className={`${classes.tableCell} ${classes.headerCell}`}
                    >
                      Material Plant ID
                    </TableCell>
                    <TableCell
                      className={`${classes.tableCell} ${classes.headerCell}`}
                    >
                      Material Storage Location ID
                    </TableCell>
                    <TableCell
                      className={`${classes.tableCell} ${classes.headerCell}`}
                    >
                      Sponsor Product Receiving Plant ID
                    </TableCell>
                    <TableCell
                      className={`${classes.tableCell} ${classes.headerCell}`}
                    >
                      Sponsor Product Receiving Storage Location ID
                    </TableCell>
                    <TableCell
                      className={`${classes.tableCell} ${classes.headerCell}`}
                    >
                      Batch Number
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell className={classes.tableCell2}>
                      {presentFormatedData(poNumber)}
                    </TableCell>
                    <TableCell className={classes.tableCell2}>
                      {presentFormatedData(
                        productDetails?.data?.productDetails?.cmo ||
                          productDetails?.data?.productDetails?.vendorName ||
                          cmoName ||
                          "NA"
                      )}
                    </TableCell>
                    <TableCell className={classes.tableCell2}>
                      {presentFormatedData(
                        `${
                          productDetails?.data?.productDetails?.productCode ||
                          fgMaterialCode ||
                          "NA"
                        } / ${
                          productDetails?.data?.productDetails
                            ?.productDescription || fgMaterialName || "NA"
                        }`
                      )}
                    </TableCell>
                    <TableCell className={classes.tableCell2}>
                      {/* {presentFormatedData(materialPlantID)} */}
                      {/* materialPlantIDFromSponsorERP */}
                      {(() => {
                        const storageLocations = [...new Set(
                          productDetails?.data?.materialDetails?.productMaterialsList
                            ?.map(item => {
                              return item?.materialPlantIDFromSponsorERP;
                            })
                            ?.filter(Boolean)
                        )]?.join(", ");
                        return presentFormatedData(storageLocations);
                      })()}
                    </TableCell>
                    <TableCell className={classes.tableCell2}>
                      {/* {presentFormatedData(materialStorageLocationID)} */}
                      {(() => {
                        const storageLocations = [...new Set(
                          productDetails?.data?.materialDetails?.productMaterialsList
                            ?.map(item => {
                              return item?.materialStorageLocationIDsFromSponsorERP;
                            })
                            ?.filter(Boolean)
                        )]?.join(", ");
                        return presentFormatedData(storageLocations);
                      })()}
                    </TableCell>
                    <TableCell className={classes.tableCell2}>
                      {/* {presentFormatedData(
                        productDetails?.data?.productDetails
                          ?.sponsorProductReceivingPlantID ||
                          productDetails?.data?.productDetails
                            ?.receivingPlantIDFromSponsorERP ||
                          "NA"
                      )} */}
                      {presentFormatedData(
                        vendorPlantID ||
                          "NA"
                      )}
                    </TableCell>
                    <TableCell className={classes.tableCell2}>
                      {/* {presentFormatedData(
                        productDetails?.data?.productDetails
                          ?.receivingStorageLocationIDsFromSponsorERP ||
                          productDetails?.data?.productDetails
                            ?.sponsorStorageLocationID ||
                          "NA"
                      )} */}
                      {presentFormatedData(
                        sponsorStorageLocation ||
                          "NA"
                      )}
                    </TableCell>
                    <TableCell className={classes.tableCell2}>
                      {presentFormatedData(batchNumber)}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      {/* )} */}

      
    </React.Fragment>
  );
};

export default ProductDetailsLoader;
